<lib-site-setup-navbar
  [stepNumber]="StepNumberEnum.ItProviderContacted"
  class="w-full"
  [loggedInUser]="vm().currentUser"
  [isNewModalDesign]="true"
  [hasBackButton]="false"
  [hasUserProfile]="false"
/>

<div
  class="mt-2 font-poppins text-[24px] font-medium leading-[34px] tracking-[-0.7px] text-[#595959] xs:text-[30px] xs:leading-[45px]"
>
  <span>{{ 'site_setup_install_options_contacting_title_part1' | translate }}</span>&nbsp;<span
    class="text-background border-0 border-r-2 border-solid border-primary-blue"
    >{{ 'site_setup_install_options_contacting_title_part2' | translate }}</span
  >
</div>

<p class="mt-5 font-poppins text-[16px] font-light leading-[24px] text-[#969696]">
  {{ 'site_setup_install_options_contacting_message' | translate }}
</p>

<button class="btn-primary mt-9 flex h-10 w-full items-center justify-center" type="button" (click)="signOut()">
  {{ 'site_setup_install_options_sign_out' | translate }}
</button>
